export default {
  default: 'DEFAULT_LEG',
  allLeg: 'ALL_LEGS',
};
